import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../auth';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [errorData, setErrorData] = useState(null);
  const [showDebugPassword, setShowDebugPassword] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setErrorData(null);
    try {
      await login(email, password);
      navigate('/');
    } catch (err) {
      setError('Login failed. Please check your credentials.');
      if (err && err.response && err.response.data) {
        setErrorData(err.response.data);
      } else if (err && err.message) {
        setErrorData({ message: err.message });
      } else {
        setErrorData(err);
      }
    } finally {
      setLoading(false);
    }
  };

  const DEBUG_MODE = import.meta.env.VITE_DEBUG_MODE === 'true';
  const IS_DEV = import.meta.env.VITE_ENVIRONMENT === 'development';
  const API_URL = import.meta.env.VITE_API_URL || '';

  return (
    <div className="mx-auto flex min-h-dvh w-full min-w-80 flex-col bg-gray-100 dark:bg-gray-900 dark:text-gray-100">
      <main id="page-content" className="flex max-w-full flex-auto flex-col">
        <div className="mx-auto flex min-h-dvh w-full max-w-10xl items-center justify-center bg-gray-200/50 p-4 lg:p-8 dark:bg-transparent">
          <div className="w-full max-w-5xl lg:py-16">
            <div className="flex flex-col overflow-hidden rounded-lg bg-white shadow-xs md:flex-row dark:bg-gray-800 dark:text-gray-100">
              {/* Sign In Form */}
              <section className="px-6 py-10 md:w-1/2 md:px-10 lg:p-16">
                <header className="mb-8 text-center sm:mt-0 md:text-left">
                  <img src="/agrolab-logo.png" alt="AgroLab Logo" className="mb-1 h-30" />
                  <h2 className="text-sm font-medium text-gray-500 dark:text-gray-400">Welcome to AgroMate, please sign in</h2>
                </header>
                <form className="space-y-6" onSubmit={handleSubmit}>
                  <div className="space-y-1">
                    <label htmlFor="email" className="inline-block text-sm font-medium">Email</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter your email"
                      className="block w-full rounded-lg border border-gray-200 px-5 py-3 leading-6 placeholder-gray-500 focus:border-emerald-500 focus:ring-3 focus:ring-emerald-500/50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-emerald-500"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div className="space-y-1">
                    <label htmlFor="password" className="inline-block text-sm font-medium">Password</label>
                    <input
                      type="password"
                      id="password"
                      name="password"
                      placeholder="Enter your password"
                      className="block w-full rounded-lg border border-gray-200 px-5 py-3 leading-6 placeholder-gray-500 focus:border-emerald-500 focus:ring-3 focus:ring-emerald-500/50 dark:border-gray-600 dark:bg-gray-800 dark:placeholder-gray-400 dark:focus:border-emerald-500"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      required
                    />
                  </div>
                  {error && <div className="text-red-500 text-sm">{error}</div>}
                  <div>
                    <button
                      type="submit"
                      className="inline-flex w-full items-center justify-center gap-2 rounded-lg border border-emerald-700 bg-emerald-700 px-6 py-3 leading-6 font-semibold text-white hover:border-emerald-600 hover:bg-emerald-600 hover:text-white focus:ring-3 focus:ring-emerald-400/50 active:border-emerald-700 active:bg-emerald-700 dark:focus:ring-emerald-400/90"
                      disabled={loading}
                    >
                      <svg
                        className="hi-mini hi-arrow-uturn-right inline-block size-5 opacity-50"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M12.207 2.232a.75.75 0 00.025 1.06l4.146 3.958H6.375a5.375 5.375 0 000 10.75H9.25a.75.75 0 000-1.5H6.375a3.875 3.875 0 010-7.75h10.003l-4.146 3.957a.75.75 0 001.036 1.085l5.5-5.25a.75.75 0 000-1.085l-5.5-5.25a.75.75 0 00-1.06.025z"
                          clipRule="evenodd"
                        />
                      </svg>
                      <span>{loading ? 'Signing In...' : 'Sign In'}</span>
                    </button>
                  </div>
                </form>
              </section>
              {/* END Sign In Form */}
              <div
                className="relative flex items-center bg-cover px-6 py-10 md:w-1/2 md:px-10 lg:p-16"
                style={{ backgroundImage: 'url(/agrolab-field.jpg)' }}
              >
                <div className="absolute inset-0"></div>
                <div className="relative text-center sm:text-left">
                  <p className="mb-2 leading-relaxed font-semibold text-white">
                    
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-5 text-center text-sm text-gray-600 dark:text-gray-400">
              Powered by{' '}
              <a href="https://itm8.com/" className="font-medium text-emerald-600 hover:text-emerald-400 dark:text-emerald-400 dark:hover:text-emerald-300" target="_blank" rel="noopener noreferrer">
                <img src="/itm8-logo.png" alt="itm8 logo" className="inline h-6 align-middle" />
              </a>
            </div>
            {/* Debug Box */}
            {DEBUG_MODE && IS_DEV && (
              <div className="mt-8 mb-3 mr-3 ml-3 rounded-lg bg-yellow-100 text-yellow-900 dark:bg-yellow-900 dark:text-yellow-100 border border-yellow-300 dark:border-yellow-700 px-4 py-3 text-xs font-mono opacity-95 shadow-lg">
                <div className="flex flex-col gap-2">
                  <div><strong className="text-emerald-700 dark:text-emerald-300">Debug Mode:</strong> <span className="text-emerald-600 dark:text-emerald-200">ON</span></div>
                  <div><strong className="text-emerald-700 dark:text-emerald-300">API Endpoint:</strong> <span className="break-all text-emerald-600 dark:text-emerald-200">{API_URL}</span></div>
                  <div className="flex items-center gap-2">
                    <strong className="text-emerald-700 dark:text-emerald-300">Credentials:</strong>
                    <span className="text-emerald-600 dark:text-emerald-200">Email: {email || <em>None</em>}, Password: {showDebugPassword ? (password || <em>None</em>) : (password ? '••••••••' : <em>None</em>)}</span>
                    {password && (
                      <button
                        type="button"
                        aria-label={showDebugPassword ? 'Hide password' : 'Show password'}
                        className="ml-1 p-0.5 rounded focus:outline-none focus:ring-2 focus:ring-emerald-400"
                        onClick={() => setShowDebugPassword(v => !v)}
                        tabIndex={0}
                      >
                        {showDebugPassword ? (
                          // Eye closed icon
                          <svg xmlns="http://www.w3.org/2000/svg" className="inline-block size-4 text-emerald-700 dark:text-emerald-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 3l18 18M10.584 10.587A3 3 0 0012 15a3 3 0 002.828-4.001M9.88 9.88A3 3 0 0112 9a3 3 0 013 3c0 .512-.152.986-.414 1.386M21 12c0 4.418-4.03 8-9 8-2.21 0-4.21-.895-5.657-2.343M3.343 7.343C4.79 5.895 6.79 5 9 5c4.97 0 9 3.582 9 8" />
                          </svg>
                        ) : (
                          // Eye open icon
                          <svg xmlns="http://www.w3.org/2000/svg" className="inline-block size-4 text-emerald-700 dark:text-emerald-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm6 0c0 4.418-4.03 8-9 8s-9-3.582-9-8 4.03-8 9-8 9 3.582 9 8z" />
                          </svg>
                        )}
                      </button>
                    )}
                  </div>
                  <div>
                    <strong className="text-red-700 dark:text-red-300">Error Message:</strong>
                    <span className="text-red-600 dark:text-red-200 ml-1">{error || <em>None</em>}</span>
                  </div>
                  {errorData && (
                    <div>
                      <strong className="text-red-700 dark:text-red-300">Returned Data:</strong>
                      <pre className="bg-gray-800 border border-red-700 rounded p-2 mt-1 overflow-x-auto max-w-full text-red-200 dark:text-red-200" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>{JSON.stringify(errorData, null, 2)}</pre>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
